
import { defineComponent, SetupContext, getCurrentInstance, onUnmounted, watch, onMounted, ref } from 'vue';
import Loading from '../components/Loading/index.vue';
import TopBar from '../components/TopBar/index.vue'
import { sendLog } from '~/common/radar';

export default defineComponent({
  components: {
    Loading,
    TopBar,
  },

  setup(props, ctx: SetupContext) {
    const { proxy } = getCurrentInstance() as any

    const addToDesktopReminder = proxy.$store.state.startup?.addToDesktopReminder || 'false'

    const loading = ref(false)
    const pageType = ref('normal')
    const downloadModel = ref(false);

    const setLoading = (isLoading: boolean) => {
      loading.value = isLoading;
    }

    const hideDownloadModel = () => {
      downloadModel.value = false;
    };

    const handleInstallWebApp = (e:Event) => {
      setTimeout(() => {
        window?.deferredPrompt?.prompt();
      }, 1000)
      window?.deferredPrompt?.userChoice.then((choiceResult: any) => {
          // @ts-ignore
          window.deferredPrompt = null;
          window.removeEventListener('click', handleInstallWebApp)
          localStorage.setItem('isShowPrompt', Date.now().toString())
          if(choiceResult.outcome === 'accepted') {
            sendLog({
                type: 'click',
                name: 'ADD_TO_DESKTOP',
                value: {
                  is_success: 1
                }
            })
          }
          else if(choiceResult.outcome === 'dismissed') {
            sendLog({
                type: 'click',
                name: 'ADD_TO_DESKTOP',
                value: {
                  is_success: 0
                }
            })
          }
      });
      // window.removeEventListener('click', handleInstallWebApp)
    }

    watch(() => proxy.$route.path, (newVal: string) => {
      if(newVal.indexOf('/video/') !== -1) {
        pageType.value = 'video'
      } else if(newVal.indexOf('/embed') !== -1) {
        pageType.value = 'embed'
      } else if(newVal.indexOf('/playlist') !== -1) {
        pageType.value = 'playlist'
      } else {
        pageType.value = 'normal'
      }

    }, {immediate: true})

    onMounted(() => {
      proxy.$bus.on('isLoad', setLoading);
      proxy.$bus.on('show-download', (val: boolean) => {
            downloadModel.value = val
      });
      if(!localStorage.getItem('isShowPrompt') && addToDesktopReminder === 'true') window.addEventListener('click', handleInstallWebApp);

    })

    onUnmounted(() => {
      proxy.$bus.off('isLoad', setLoading)
    })

    return {
      loading,
      pageType,
      downloadModel,
      hideDownloadModel,
      handleInstallWebApp
    }
  },
  head() {
    const host = (this as any).$host || location?.host
    const languagemap = (this as any).$i18n.localeCodes.map((el: string) => {
      return {
        rel: 'alternate',
        hreflang: el,
        href: `https://${host + decodeURI(this.$route.path)}?lang=${el}`
      }
    })

    return {
      link: [
        {
          rel: 'canonical',
          href: `https://${host + decodeURI(this.$route.path)}`
        },
        ...languagemap,
      ],
    }
  },
})
